import { render, staticRenderFns } from "./DealEntry.vue?vue&type=template&id=0633a4e3&scoped=true"
import script from "./DealEntry.vue?vue&type=script&lang=js"
export * from "./DealEntry.vue?vue&type=script&lang=js"
import style0 from "./DealEntry.vue?vue&type=style&index=0&id=0633a4e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0633a4e3",
  null
  
)

export default component.exports